const constants = {};
const SHEET_NAME = "Sheet";
const SHEET_HANDLE_NAME = "SheetHandle";
export {
  SHEET_HANDLE_NAME,
  SHEET_NAME,
  constants
};
//# sourceMappingURL=constants.js.map
